<!-- 工作台 -->
<template>
  <div>
    <div class="form-main">
      <el-form :model="formData" ref="formData" label-width="120px" class="formData">
        <div>
          <el-form-item label="AppKey">
            <el-input v-model="formData.AppKey" placeholder="在钉钉开发者平台中创建一个小程序应用后就会生成"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="AppSecret">
            <el-input v-model="formData.AppSecret" placeholder="在钉钉开发者平台中创建一个小程序应用后就会生成"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="加密 aes_key">
            <el-input v-model="formData.AESKey" placeholder="在钉钉开发者平台时间订阅中点击重置自动生成"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="签名 token">
            <el-input v-model="formData.CallBackToken" placeholder="在钉钉开发者平台时间订阅中点击重置自动生成"></el-input>
          </el-form-item>
        </div>
         <div>
          <el-form-item label="钉钉开发者后台">
            <span>https://open.dingtalk.com/</span>
          </el-form-item>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancel()">关闭</el-button>
        <el-button class="btn-primary" @click="submitForm">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["DeviceId"],
  name: "",
  data() {
    return {
      formData: {}
    };
  },
  mounted() {
    if (this.DeviceId) this.getDeviceInfo();
  },
  methods: {
    getDeviceInfo() {
      let url = "/api/AttendanceSystem/GetDingTalkeDevicesInfo";
      this.$util
        .axiosGet({
          url: url,
          data: {
            deviceId: this.DeviceId
          }
        })
        .then(res => {
          if (res.data) {
            this.formData = res.data;
          }
        })
        .catch(() => {});
    },
    // 提交表单
    submitForm() {
      let that = this;
      let url = "/api/AttendanceSystem/SaveDingDeviceInfoes";
      that.$util
        .axiosPost({
          url: url,
          data: that.formData
        })
        .then(res => {
          if (res.errcode == 0) this.$util.successMsg(res.errmsg);
          else this.$util.errorMsg(res.errmsg);
          this.$emit("closeDialog", true);
        })
        .catch(() => {});
    },
    cancel() {
      this.$emit("closeDialog");
    }
  }
};
</script>
<style lang="less" scoped>
.form-value {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}
.form-column {
  width: 33.33%;
}
.dialog-footer {
  text-align: right;
}
</style>
